export const API_URL = process.env.API_URL;
export const SIGNIN_URL = process.env.SIGNIN_URL;
export const PUBLIC_LEGAL = process.env.PUBLIC_LEGAL;
export const URL_IMAGE = process.env.URL_IMAGE;
export const MIXPANEL_TOKEN = process.env.MIXPANEL_TOKEN;
export const HOTJAR_ID = process.env.HOTJAR_ID;
export const IFM_CSAT_URL = process.env.IFM_CSAT_URL;
export const SUPPORT_URL = process.env.SUPPORT_URL;
